module.exports = __webpack_public_path__ + "img/bj.ef9c7bf6.png";